import {Grid} from '@mui/material'
import Button from '../../shared/UI/Button'
import AutocompleteList from '../../shared/UI/AutocompleteList'
import {EnhancementReportSearch} from './hooks/useEnhancementsFilter'
import PayPeriodPicker from './PayPeriodPicker'
import {SelectOption} from '../../services/dashboardService'
import {PayPeriodData} from '../../models/enhancement/pay-period-data'

export interface EnhancementFilterActions {
  setSelectedDepartments: (newValue: SelectOption[]) => void;
  setSelectedTeams: (newValue: SelectOption[]) => void;
  handleFromPayPeriodChange: (payPeriod: PayPeriodData | null) => void;
  handleToPayPeriodChange: (payPeriod: PayPeriodData | null) => void;
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}

export interface EnhancementFilterData {
  selectedDepartments: SelectOption[];
  selectedTeams: SelectOption[];
  fromPayPeriod: PayPeriodData | null;
  toPayPeriod: PayPeriodData | null;
  departmentsList: SelectOption[];
  teamList: SelectOption[];
}

interface EnhancementsReportFilterProps extends EnhancementFilterActions, EnhancementFilterData {
  showSearchButton?: boolean;
}

function EnhancementsReportFilter({
                                    selectedDepartments,
                                    setSelectedDepartments,
                                    selectedTeams,
                                    setSelectedTeams,
                                    fromPayPeriod,
                                    toPayPeriod,
                                    handleFromPayPeriodChange,
                                    handleToPayPeriodChange,
                                    departmentsList,
                                    teamList,
                                    handleSubmit,
                                    showSearchButton = true,
                                  }: Readonly<EnhancementsReportFilterProps>) {

  return (
    <Grid
      container
      spacing={2}
      component="form"
      data-testid="enhancements-report-filter-form"
      noValidate
      mt={0}
      onSubmit={handleSubmit}
    >
      <Grid item xs={12}>
        <PayPeriodPicker
          fromPeriod={fromPayPeriod}
          toPeriod={toPayPeriod}
          onFromChange={handleFromPayPeriodChange}
          onToChange={handleToPayPeriodChange}
          arrange="Horizontal"
          dataTestId="EnhancementReporting-PayPeriodPicker"
        />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <AutocompleteList
              multiple
              id="department"
              label="Department"
              data={departmentsList}
              textField="displayValue"
              value={selectedDepartments}
              onChange={(e, newValue) => setSelectedDepartments(newValue ?? [])}
              dataTestId="EnhancementReporting-DepartmentDDL"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <AutocompleteList
              multiple
              id="team"
              label="Teams"
              data={teamList}
              textField="displayValue"
              value={selectedTeams}
              onChange={(e, newValue) => setSelectedTeams(newValue ?? [])}
              dataTestId="EnhancementReporting-TeamsDDL"
            />
          </Grid>
        </Grid>
      </Grid>
      {showSearchButton && (
        <Grid item xs={12} pt={0} mt={0} display="flex" justifyContent="flex-end">
          <Button label="Search" type="submit" dataTestId="EnhancementReporting-SearchBtn" />
        </Grid>
      )}
    </Grid>
  )
}

export default EnhancementsReportFilter